import moment from "moment";
import { useDispatch } from "react-redux";
import {
  getAppoinmentAction,
  getAppointmentQueueFilterCountsAction,
} from "../../../redux/actions/AppoinmentAction";
import { getRole } from "../../../Utils/types";
import {
  clearCurrentPage,
  updateDurationDate,
} from "../../NetworkPortal/ProviderProfileDetails/helper";
import { useEffect } from "react";

export const FunnelBoxDetail = [
  {
    heading: "Today’s Appointments",
    funnelType: "todayAppointment",
    status: "A,P,N,E,C,K",
    fromDate: moment(new Date()).format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  {
    heading: "Upcoming Appointments",
    funnelType: "upcomingAppointment",
    status: null,
    fromDate: moment().add(1, "days").format("YYYY-MM-DD"),
    toDate: moment().add(30, "days").format("YYYY-MM-DD"),
  },
  {
    heading: "Total Appointments",
    funnelType: "totalAppointment",
    status: null,
    fromDate: moment(new Date()).format("YYYY-MM-DD"),
    toDate: moment().add(30, "days").format("YYYY-MM-DD"),
  },
  {
    heading: "Pending Confirmation",
    funnelType: "pendingConfirmation",
    status: "P",
    fromDate: moment(new Date()).format("YYYY-MM-DD"),
    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
  },
  {
    heading: "Mark Patient Visit",
    funnelType: "markPatientVisit",
    status: "A,K",
    fromDate:
      getRole() === "NetworkAdmin"
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  {
    heading: "Partial Show",
    funnelType: "partialShow",
    status: "Z",
    fromDate:
      getRole() === "NetworkAdmin"
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  {
    heading: "Pending ReportUpload",
    funnelType: "reportPending",
    status: "S,H",
    fromDate:
      getRole() === "NetworkAdmin"
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
  {
    heading: "Closed Appointments",
    funnelType: "completed",
    status: "U",
    fromDate:
      getRole() === "NetworkAdmin"
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment().subtract(30, "days").format("YYYY-MM-DD"),
    toDate: moment(new Date()).format("YYYY-MM-DD"),
  },
];

export const FunnelBox = ({
  heading,
  setMultiSelect,
  count,
  selectedFunnel,
  searchFilter,
  setFunnelSelected,
  type,
  data,
  setSearchFilter,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (type) {
      setSearchFilter({ ...searchFilter, FilterPresetName: type });
    }
  }, [type]);

  return (
    <div
      className="col-lg-3 col-xl-3 col-xxl-3 col-md-3 col-sm-6 col-12"
      style={{ padding: "4px", cursor: "pointer" }}
      onClick={async () => {
        await setFunnelSelected(type);
        dispatch(getAppoinmentAction({ ...data, FilterPresetName: type }));
        dispatch(
          getAppointmentQueueFilterCountsAction({
            ...data,
            FilterPresetName: type,
          })
        );
        await setSearchFilter({ ...data, FilterPresetName: type });
        await clearCurrentPage(dispatch);
        await updateDurationDate(dispatch, data?.fromDate, data?.toDate);
        await setMultiSelect([]);
      }}
    >
      <div
        className={`d-flex appbox ${
          selectedFunnel ? "__show-appbox" : "appbox"
        }`}
        style={{ justifyContent: "space-between" }}
      >
        <div>
          <i className="fas fa-hand-holding-heart icon"></i>
        </div>
        <div className="numtext">
          <div>
            <h2>{count}</h2>
          </div>
          <div>
            <p>{heading}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
